import config from '../config.json';

export const SUPPORTED_CHAIN_IDS = Object.freeze([31337, 11155111]);
export const SEPOLIA_CHAIN_ID = 11155111;
export const HARDHAT_CHAIN_ID = 31337;
export const SEPOLIA_HEX = '0xaa36a7';

export function getNetworkConfig(chainId) {
  if (chainId === null || chainId === undefined) return null;
  const key = String(chainId);
  return config[key] || null;
}

export function isSupportedChain(chainId) {
  return getNetworkConfig(chainId) !== null;
}

export function getNetworkLabel(chainId) {
  if (Number(chainId) === SEPOLIA_CHAIN_ID) return 'Sepolia';
  if (Number(chainId) === HARDHAT_CHAIN_ID) return 'Localhost 31337';
  if (chainId === null || chainId === undefined) return 'Not connected';
  return `Unsupported (${chainId})`;
}

export async function switchToSepolia() {
  if (!window.ethereum) {
    throw new Error('No wallet provider found');
  }
  try {
    await window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: SEPOLIA_HEX }],
    });
  } catch (error) {
    // 4902 = chain not added to wallet
    if (error && (error.code === 4902 || error.code === '4902')) {
      await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [
          {
            chainId: SEPOLIA_HEX,
            chainName: 'Sepolia',
            nativeCurrency: { name: 'Sepolia ETH', symbol: 'ETH', decimals: 18 },
            rpcUrls: ['https://ethereum-sepolia-rpc.publicnode.com'],
            blockExplorerUrls: ['https://sepolia.etherscan.io'],
          },
        ],
      });
      return;
    }
    throw error;
  }
}
